import React, { useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';

interface EditorTabsCloseButtonProps {
    hasModified: boolean;
}

const EditorTabsCloseButton: React.FC<EditorTabsCloseButtonProps> = ({ hasModified }) => {
    const [hover, setHover] = useState(false);

    return (
        <div
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{ display: 'inline-block', position: 'relative' }}
        >
            {hasModified && !hover ? (
                <div className='flex justify-center items-center' style={{ width: 12, height: 12 }}>
                    <div
                        style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            backgroundColor: '#1677FF',
                            transform: 'translate(25%, -25%)',
                        }}
                    />
                </div>
            ) : (
                <CloseOutlined />
            )}
        </div>
    );
};

export default EditorTabsCloseButton;